import { createBrowserRouter } from 'react-router-dom';

import { routes } from './routes';

/**
 * The browser router. Kept apart from the route tree so tests can mount the
 * same `routes` in a memory router without touching history.
 */
export const router = createBrowserRouter(routes);
